<template>
    <modal name="referensiPemilikBarang" :draggable="false" :scrollable="true" :height="'auto'">
        <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
            <div class="modal-dialog  modal-xl">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"> {{ $t("referensi_pemilik_barang") }} </h5>
                        <button type="button" class="btn btn-default" @click.prevent="removeModals()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">

                        <vue-good-table title="exim-ceisa-pemilik-barang-list" ref="exim-ceisa-pemilik-barang-list"
                            mode="remote" @on-page-change="onPageChangePemilikBarang"
                            @on-sort-change="onSortChangePemilikBarang" @on-column-filter="onColumnFilterPemilikBarang"
                            @on-per-page-change="onPerPageChangePemilikBarang" :totalRows="totalRecordsPemilikBarang"
                            :line-numbers="true" :isLoading.sync="isLoadingPemilikBarang" :pagination-options="{

                                enabled: true,
                                perPageDropdown: [10, 50, 100, 1000, 10000],
                                dropdownAllowAll: false,
                            }" :rows="rowsPemilikBarang" :columns="columnsPemilikBarang">



                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'actions'">
                                    <a href="#" title="Add" @click.prevent="addDataPemilikBarang(props.index, props.row)">
                                        <i class="mdi mdi-bookmark-plus" style="font-size:16px"></i>
                                    </a>
                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>
                        </vue-good-table>


                    </div>


                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{
                            this.$t("close_txt") }}</button>
                    </div>


                </div>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name: "ModalReferensiPemilikBarang",
    data() {
        return {
            serverParamsPemilikBarang: {
                columnFilters: {},
                sort: {
                    field: "",
                    type: "",
                },
                page: 1,
                per_page: 10,
            },


            totalRecordsPemilikBarang: 0,
            rowsPemilikBarang: [],
            columnsPemilikBarang: [

                {
                    label: this.$t('name'),
                    field: "name",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },

                {
                    label: this.$t('countryTxt'),
                    field: "country",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },


                {
                    label: this.$t('identity_number'),
                    field: "identity_number",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },



                {
                    label: this.$t('nib'),
                    field: "nib",
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [],
                        trigger: "enter", //only trigger on enter not on keyup
                    },

                },

                {
                    label: this.$t("action_txt"),
                    field: "actions",
                    thClass: 'text-center',
                    sortable: false,
                    filterOptions: {
                        customFilter: false,
                    }
                },

            ],

            isLoadingPemilikBarang: false,

        }
    },
    methods: {
        addDataPemilikBarang(index, row) {
            this.$emit("setValue", row);
            this.$modal.hide('referensiPemilikBarang');
            

        },

        // load items pemilik barang
        loadItemsPemilikBarang() {
            const baseURI = this.$settings.endPointCeisa + "v1/customer/index";
            this.isLoadingPemilikBarang = true;

            return this.$http
                .get(
                    baseURI +
                    `?limit=${this.serverParamsPemilikBarang.per_page}&page=${this.serverParamsPemilikBarang.page}&sort_field=${this.serverParamsPemilikBarang.sort.field}&sort_type=${this.serverParamsPemilikBarang.sort.type}&name=${this.serverParamsPemilikBarang.columnFilters.name}&country=${this.serverParamsPemilikBarang.columnFilters.country}&identity_number=${this.serverParamsPemilikBarang.columnFilters.identity_number}&nib=${this.serverParamsPemilikBarang.columnFilters.nib}&type=PEMILIK_BARANG`,
                    { timeout: 120000 })
                .then((response) => {

                    this.isLoadingPemilikBarang = false;
                    this.rowsPemilikBarang = response.data.datas.data;
                    this.totalRecordsPemilikBarang = response.data.datas.total;

                }).catch((error) => {
                    this.loading();

                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));

                    } else {

                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                                this.$router.push('/server-error');
                            } else {
                                this.$router.push('/page-not-found');
                            }
                        }

                    }
                });
        },

        updateParamsPemilikBarang(newProps) {
            this.serverParamsPemilikBarang = Object.assign({}, this.serverParamsPemilikBarang, newProps);
            this.loadItemsPemilikBarang();
        },

        onColumnFilterPemilikBarang(params) {
            this.updateParamsPemilikBarang(params);
        },

        onPageChangePemilikBarang(params) {
            this.updateParamsPemilikBarang({ page: params.currentPage });
        },

        onSortChangePemilikBarang(params) {
            this.updateParamsPemilikBarang({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
            });
        },

        onPerPageChangePemilikBarang(params) {
            this.updateParamsPemilikBarang({ per_page: params.currentPerPage });
        },
        removeModals() {
            this.$modal.hide('referensiPemilikBarang');
            
        }
    },
    created: function () {
        this.loadItemsPemilikBarang();
    },
}
</script>

<style></style>